<template>
  <div>


    <!--   devices filter-->
    <b-card>
      <b-card-title>{{ $t('Devices filters')}}</b-card-title>
      <b-row>
        <b-col md="12">
          <b-form-group :label="$t('Owners')">
            <v-select multiple :close-on-select="false" v-model="selectedOwners"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :getOptionLabel="o => o.name"
                      :options="ownersFilter"
                      :reduce="o => o.id" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('Contracts')">
            <v-select multiple :close-on-select="false" v-model="selectedContracts"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :getOptionLabel="c => c.name"
                      :options="contractsOptions"
                      :reduce="c => c.id" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- form report -->
    <b-card style="position: relative" :title="$t('Select Devices & Time')">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="submitReport">
        <b-row class="mt-2">
          <b-col>
            <b-form-group :label="$t('devices')" label-for="vi-device-id">
              <v-select multiple :close-on-select="false" v-model="request.devices_ids"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), device_id: 'all' }, ...devices]" :reduce="d => d.device_id" />
              <small v-if="errors && ('devices_ids' in errors)" class="text-danger">
                {{ $t(errors['devices_ids'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...conf }"
                placeholder=" new Date()" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{ ('from' in errors) ? errors['from'][0] : '' }}
                {{ ('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Show Report') }}
            </b-button>
          </b-col>

        </b-row>
      </b-form>
    </b-card>

    <div v-if="result.length > 0">
      <b-card>

        <div v-if="loading" class="loading_page">
          <orbit-spinner :animation-duration="1000" :size="40" :color="'#0e96b1'" />
        </div>

        <b-row>
          <b-col cols="12" md="12" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">

            <div class="col-12 mb-1 d-flex justify-content-end">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="export_file('pdf')"
                        type="button" variant="primary" class="mr-1 btn">
                {{ $t('pdf') }}
              </b-button>

              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="export_file('xlsx')"
                        type="button" variant="primary" class="mr-1 btn">
                {{ $t('Excel') }}
              </b-button>
            </div>

          </b-col>
          <b-table class="table table-sm"
                   responsive
                   small
                   :sort-compare="sortCompare"
                   :fields="fields.map((i) => ({ key: i.key, label: $t(i.label), sortable: i.sortable }))"
                   :items="result">

            <template #cell(id)="data">
                {{++data.index}}
            </template>

          </b-table>

        </b-row>

        <div class="mb-1">
            <span class="text-muted">{{ $t('Showing') }}
              {{ ((currentPage - 1) * perPage + 1) }} to
              {{ Math.min( ((currentPage - 1) * perPage + 1)  + perPage - 1, result.length) }}
              of {{ result.length }} {{$t('entries')}}
            </span>
        </div>

        <b-pagination v-model="currentPage" :total-rows="result.length"
                      :per-page="perPage" aria-controls="my-table"></b-pagination>

      </b-card>
    </div>


  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, VBTooltip,
  BInputGroupAppend, BCardTitle, BModal
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted, computed, reactive, watch } from '@vue/composition-api'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DataTable from '@/views/reports/data-table/DataTable.vue'
import { conf, rangeDate, from, to } from '@/views/reports/SweeperService/_datepicker'
import fields from '@/views/reports/routeDistance/fields'
import { createToastInterface } from "vue-toastification"
import axios from '@/libs/axios'
import store from '@/store'


export default {
  components: {
    BCardTitle,
    BRow,
    BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab, BModal,
    vSelect,
    OrbitSpinner, BInputGroupAppend,
    ToggleCollapse,
    DataTable
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },

  setup() {

    const myTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(25)
    const result = ref([]);
    const errors = ref([]);
    const export_status = ref(false)


    const isModalOpen = ref(false)
    const selectedRowData = ref(null)


    const request = reactive({
      type: 'routeDistance',
      devices_ids: [],
      owners: [],
      contracts: [],
      from: from,
      to: to,
      needPagination: false
    })

    const pluginOptions = {
      position: "bottom-right",
      timeout: false,
      closeOnClick: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: false,
      draggablePercent: 0.12,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon: true,
      rtl: false
    }

    const toast = createToastInterface(pluginOptions)

    const loading = ref(false)
    const devices = ref([])

    const selectedOwners = ref([])
    const selectedContracts = ref([])

    const contractsOptions = computed(() => {
      return contractsFilter.value.filter(i =>
          selectedOwners.value.includes(i.contractor_id))
    })
    const devicesOptions = computed(() => {
      return devices.value.filter(i =>
          (selectedOwners.value.length === 0 && selectedContracts.value.length === 0 )||
          (selectedOwners.value.includes(i.owner_id) ||
              selectedContracts.value.includes(i.contract_id)))
    })

    watch([selectedOwners, selectedContracts], () => {
      request.contracts = selectedContracts.value
      request.owners = selectedOwners.value
    })

    watch([perPage], () => {
      request.perPage = perPage.value
      submitReport()
    })

    const getDevices = _ => {
      axios.get('userGetLinked', {params: {
          user: store.state.auth.userData.id,
          type: 'device',
          cols: 'device_id,name,owner_id,contract_id',
          category: 'COMPACTOR',
        }}).then(res => devices.value = res.data.data).catch(e => {})
    }

    getDevices()

    const ownersFilter =  ref([])
    const contractsFilter =  ref([])

    axios.get('filters/getFilterBy', { params: {
        type: 'device' }})
        .then(res => {
          ownersFilter.value = res.data.data.owners
          contractsFilter.value = res.data.data.contracts
        })
        .catch(e => {})

    const handlePageChange = page => {
      request.page = page
      submitReport()
    }

    const handlePerPageChange = page => {
      // console.log(page)
    }

    const submitReport = () => {

      loading.value = true
      errors.value = []

      axios.post('reports', request).then(res => {
        console.log(res.data.data)
        result.value = res.data.data.rows
      }).catch(e => {
        if (e.response.status === 422) {
          errors.value = e.response.data.errors
        }
      }).finally(_ => loading.value = false)

    }

    const export_file = type => {
      toast.info('جاري تحميل الملف ...')
      export_status.value = true
      loading.value = true
      axios.post(
          'export',
          { exporter: type, export: "routeDistanceReport", ...request },
          {responseType: 'blob'}
      )

          .then(res => {
            const blob = new Blob(
                [res.data],
                { type: res.headers['content-type'], encoding: 'UTF-8' }
            );
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `route_distance_report.${type}`;
            link.click();
            URL.revokeObjectURL(url);
          })

          .catch(e => console.log('error export report'))
          .finally(_ => {
            export_status.value = false
            loading.value = false
            toast.clear()
          })

    }

    const sortCompare = (a, b, k) => {

    }

    const openModal = rowItem => {
      selectedRowData.value = rowItem.areas
      isModalOpen.value = true
    }

    return {

      myTable,
      currentPage,
      perPage,
      fields,conf, rangeDate,

      result, errors,
      loading, export_status,
      devices,

      isModalOpen,selectedRowData,

      // filters
      ownersFilter, contractsFilter,
      selectedOwners, selectedContracts,
      contractsOptions,

      // computed
      devicesOptions,
      request,
      submitReport,
      export_file,
      handlePageChange,
      handlePerPageChange,
      sortCompare,
      openModal
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.group-row {
  background-color: #ddd;
}
</style>
